<template>
  <div id="solution_view">
    <div class="headline">
      <div class="describe">{{ $t("solution.SOLUTION_DESCRIPTION") }}</div>
      <div class="title">{{ $t("solution.SOLUTION_TITLE") }}</div>
      <!-- <div class="button" @click="onScroll">{{ $t("solution.READ_MORE") }}</div> -->
    </div>
    <div class="assets" ref="airToLiquidCooling">
      <div class="asset">
        <div
          class="asset_content"
          :style="{ 'flex-direction': shrink ? 'column' : 'row-reverse' }"
          v-fadeIn
        >
          <div class="thunbnail">
            <img
              src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_front.png"
              alt=""
            />
          </div>
          <div class="introduce">
            <div class="label">{{ $t("solution.AIR_TO_LIQUID") }}</div>
            <div class="label_description">
              {{ $t("solution.AIR_TO_LIQUID_DESCRIPTION") }}
            </div>
            <div class="options">
              <div class="option" v-for="(item, index) in 5" :key="index">
                <div class="icon">
                  <img src="@/assets/product/correct.svg" alt="" />
                </div>
                <span>{{ $t(`solution.AIR_TO_LIQUID_OPTIONS_${index}`) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="asset" ref="systemicLiquidCooling">
        <div
          class="asset_content"
          :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
          v-fadeIn
        >
          <div class="thunbnail">
            <img
              src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/systemic_Liquid_cooling%20_renovation_solution.png"
              alt=""
            />
          </div>
          <div class="introduce">
            <div class="label">{{ $t("solution.LIQUID_TO_LIQUID") }}</div>
            <div class="label_description">
              {{ $t("solution.LIQUID_TO_LIQUID_DESCRIPTION") }}
            </div>
            <div class="options">
              <div class="option" v-for="(item, index) in 5" :key="index">
                <div class="icon">
                  <img src="@/assets/product/correct.svg" alt="" />
                </div>
                <span>{{
                  $t(`solution.LIQUID_TO_LIQUID_OPTIONS_${index}`)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="asset" ref="RDHxAirCooled">
        <div
          class="asset_content"
          :style="{ 'flex-direction': shrink ? 'column' : 'row-reverse' }"
          v-fadeIn
        >
          <div class="thunbnail">
            <img
              src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/rear_door_heat%20_exchange.png"
              alt=""
            />
          </div>
          <div class="introduce">
            <div class="label">{{ $t("solution.LIQUID_TO_AIR_0") }}</div>
            <div class="label" style="margin-top: -15px">
              {{ $t("solution.LIQUID_TO_AIR_1") }}
            </div>
            <div class="label_description">
              {{ $t("solution.LIQUID_TO_AIR_DESCRIPTION") }}
            </div>
            <div class="options">
              <div class="option" v-for="(item, index) in 5" :key="index">
                <div class="icon">
                  <img src="@/assets/product/correct.svg" alt="" />
                </div>
                <span>{{ $t(`solution.LIQUID_TO_AIR_OPTIONS_${index}`) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import provide_key from "@/constant/provide_key";
import routerHash from "@/constant/router_hash";
import { inject, ref, onMounted, onUnmounted, onActivated } from "vue";
import Mitt from "@/utils/mitt";

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const airToLiquidCooling = ref<HTMLDivElement | null>(null);
const systemicLiquidCooling = ref<HTMLDivElement | null>(null);
const RDHxAirCooled = ref<HTMLDivElement | null>(null);

const onScroll = () => {
  const remToPx = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  const remValue = 49;
  const pxValue = remValue * remToPx;

  window.scrollTo({
    top: pxValue,
    behavior: "smooth",
  });
};

onMounted(() => {
  Mitt.on(routerHash.AIR_TO_LIQUID_COOLING, () =>
    airToLiquidCooling.value!.scrollIntoView(true)
  );
  Mitt.on(routerHash.SYSTEMIC_LIQUID_COOLING, () =>
    systemicLiquidCooling.value!.scrollIntoView(true)
  );
  Mitt.on(routerHash.RDHX_AIR_COOLED, () =>
    RDHxAirCooled.value!.scrollIntoView(true)
  );
});

onUnmounted(() => {
  Mitt.off(routerHash.AIR_TO_LIQUID_COOLING);
  Mitt.off(routerHash.SYSTEMIC_LIQUID_COOLING);
  Mitt.off(routerHash.RDHX_AIR_COOLED);
});

onActivated(() => window.scrollTo({ top: 0 }));
</script>

<style lang="less" scoped>
#solution_view {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  animation: fadeIn 1s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .headline {
    width: 100%;
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    height: 30rem;
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.7)
      ),
      url("@/assets/solution/solution_thumbnail.png");
    background-size: cover;

    .title {
      max-width: 48rem;
      font-size: var(--primary-title);
      margin-bottom: 1rem;
      overflow: hidden;
      text-align: center;
      margin-top: 0.75rem;
      line-height: 3.8rem;
      color: #fff;
      animation: fadeIn 1s 0.5s forwards;
      opacity: 0;
      font-weight: 700;
      font-family: "HarmonyOS_Bold";
    }

    .describe {
      font-size: var(--primary-text);
      color: #fff;
      animation: fadeIn 1s 0.5s forwards;
      opacity: 0;
    }

    .button {
      background: #002fa5;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 20px;
      margin-top: 1.4rem;
      color: #fff;
      cursor: pointer;
      border-radius: 0.5rem;
      animation: fadeIn 1s 1s forwards;
      opacity: 0;
      font-size: 0.8rem;

      &:hover {
        background: #073dc4;
      }
    }
  }

  .assets {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6rem;

    .asset {
      background: #f7f7f7;
      background-size: cover;
      width: 100%;
      padding: 4rem 0;

      &_content {
        max-width: var(--view-max-width);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        color: #fff;
        margin: 0 auto;
      }

      .thunbnail {
        height: 25rem;
        min-width: 29rem;
        overflow-y: hidden;

        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }

      .introduce {
        max-width: 90%;
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .label {
          font-size: var(--label-title);
          font-weight: 700;
          overflow: hidden;
          line-height: 3rem;
          color: #111;
        }

        .label_description {
          font-size: var(--label-description);
          font-weight: 400;
          color: #333;
        }

        .options {
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
          font-size: var(--label-description);
          margin-left: 0.8rem;

          .option {
            display: flex;
            gap: 12px;
            color: #757575;
            align-items: center;

            .icon {
              width: 1.5rem;
              overflow: hidden;
              flex-shrink: 0;

              img {
                vertical-align: middle;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>